import { IKnmListByPlanFilterExtraField } from '../interfaces/IKnmListByPlanFilterExtraField';

export const initialKnmListByPlanFilterAdditionalFields: IKnmListByPlanFilterExtraField[] = [
  {
    id: 'supervisionType',
    name: 'Вид контроля (надзора)',
    isSelected: false,
  },
  {
    id: 'objectsType',
    name: 'Тип объекта',
    isSelected: false,
  },
  {
    id: 'objectsKind',
    name: 'Вид объекта',
    isSelected: false,
  },
  {
    id: 'objectsSubKind',
    name: 'Подвид объекта',
    isSelected: false,
  },
  {
    id: 'isHasRequirements',
    name: 'Наличие обязательных требований',
    isSelected: false,
  },
  {
    id: 'isHasApproveDocs',
    name: 'Наличие разрешительных документов',
    isSelected: false,
  },
  {
    id: 'startDateBetween',
    name: 'Дата начала КНМ (интервал)',
    isSelected: false,
  },
  {
    id: 'kinds',
    name: 'Вид КНМ',
    isSelected: false,
  },
  {
    id: 'events',
    name: 'Действия',
    isSelected: false,
  },
  {
    id: 'isHasCollaboratingOrganization',
    name: 'Проводится совместно',
    isSelected: false,
  },
  {
    id: 'signed',
    name: 'Подписано ЭП',
    isSelected: false,
  },
];
